import  SubscriptionPopup from "../../components/subscriptionPopup"

export const Subscription = () => <SubscriptionPopup />
